import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getPageTitleFromUrl } from '../../utils/googleAnalytics';

const GOOGLE_TAG_MANAGER_ID = process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID;

function GoogleAnalytics({ enabled = true }) {
	const location = useLocation();

	const pathname = location?.pathname || '/';
	const pageTitle = getPageTitleFromUrl(pathname);

	const { t } = useTranslation('common');

	if (!enabled) {
		return (
			<Helmet>
				<title>{pageTitle || t('app_name')}</title>
			</Helmet>
		);
	}

	return (
		<Helmet>
			<title>{pageTitle || t('app_name')}</title>
			<script>
				{`
          <!-- Google Tag Manager -->
					(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
					new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
					j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
					'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
				})(window,document,'script','dataLayer', '${GOOGLE_TAG_MANAGER_ID}');
				<!-- End Google Tag Manager -->
     `}
			</script>
		</Helmet>
	);
}

GoogleAnalytics.propTypes = {
	enabled: PropTypes.bool,
};

export default GoogleAnalytics;
